module.exports = __webpack_public_path__ + "media/images/btn_apple_store_2x-fd3529c3.png";